import { FontAwesome6 } from "@expo/vector-icons";
import { Text } from "@ui-kitten/components";
import Chevron from "components/Chevron";
import { Image } from "expo-image";
import { AccountTicketDetails } from "features/types";
import { useAccount } from "hooks/useAccount";
import i18n from "plugins/localization";
import React from "react";
import { StyleSheet, View } from "react-native";
import { formatEventDate, isSportsEvent } from "utils/eventUtils";
import { svgURL } from "utils/fileUtils";

interface EventListItemProps {
  eventDetail: AccountTicketDetails;
}
const EventListItem: React.FC<EventListItemProps> = ({ eventDetail }) => {
  const {
    event: { name, type, opponentName },
    tickets,
    groupCode,
  } = eventDetail;
  const { account } = useAccount();

  if (account === null) return null;

  const opponentLogo = svgURL(opponentName, false);

  return (
    <View style={styles.container}>
      <View style={{ flexShrink: 1 }}>
        <Text style={{ fontSize: 20, fontWeight: "bold" }}>{name}</Text>
        {type !== "EXPERIENCE" && (
          <Text style={{ fontSize: 16 }}>
            {formatEventDate(eventDetail.event)}
          </Text>
        )}
        <Text style={{ fontSize: 14 }}>
          {i18n.t("screens.MyEvents.myReservations", { size: tickets.length })}
        </Text>
        <Text style={{ fontSize: 14 }}>
          {i18n.t("screens.MyEvents.groupSize", {
            size: groupCode.tickets.filter((t) =>
              ["RESERVED", "ISSUED", "SCANNED"].includes(t.status)
            ).length,
          })}
        </Text>
      </View>
      <View
        style={{
          height: 80,
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {isSportsEvent(type) && (
          <Image
            source={{
              uri: opponentLogo,
            }}
            style={{
              width: 120,
              height: 80,
            }}
            contentFit="contain"
            responsivePolicy="initial"
          />
        )}
        {type === "PARKING" && (
          <View className="w-[120px] h-[80px] justify-center items-center">
            <FontAwesome6 name="square-parking" size={80} color="#025b9a" />
          </View>
        )}
        <Chevron />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottomColor: "rgba(0,0,0,0.05)",
    borderBottomWidth: 1,
    paddingVertical: 10,
  },
});

export default EventListItem;
